
import { Injectable } from '@angular/core';
import { Response, RequestOptionsArgs, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import'rxjs/add/operator/do';
import'rxjs/add/operator/catch';
import'rxjs/add/operator/map';
import'rxjs/add/observable/throw';

import { Subscription } from './store/subscriptions.model';
import { HttpInterceptorService } from '@covalent/http/index';
export class SubscriptionsService {
/**
 * @param {?} httpInterceptorService
 */
constructor(private httpInterceptorService: HttpInterceptorService) { }
/**
 * @return {?}
 */
getSubscriptions(): Observable<Subscription[]> {

    return this.httpInterceptorService.get('subscriptions')
      .map((res: Response): Subscription[] => {
        const /** @type {?} */ body = res.json();
        // TODO: check at runtime that body matches the structure of Sub
        return body;
      });

  };
/**
 * @param {?} error
 * @return {?}
 */
private handleError(error: Response) {
    // in a real world app, we should consider to some remote logging infrastructure
    // instead of just logging it to the console
    return Observable.throw(error.json().error || 'Server error');
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpInterceptorService, },
];
}

function SubscriptionsService_tsickle_Closure_declarations() {
/** @type {?} */
SubscriptionsService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SubscriptionsService.ctorParameters;
/** @type {?} */
SubscriptionsService.prototype.httpInterceptorService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
